(function () {
  'use strict';

  function initHomepageHeader() {
    if (!document.querySelector('.ps-hp2-hero')) return;
    var header = document.querySelector('#header-component');
    if (!header || header.dataset.psHp2ScrollReady === 'true') return;

    header.dataset.psHp2ScrollReady = 'true';
    document.documentElement.classList.add('ps-hp2-home');
    var lastY = window.scrollY;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      var movingDown = y > lastY + 4;
      var movingUp = y < lastY - 4;
      if (y < 120 || movingUp) header.classList.remove('ps-hp2-header-hidden');
      else if (movingDown) header.classList.add('ps-hp2-header-hidden');
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
  }

  function initHeroSlider() {
    var slider = document.querySelector('[data-ps-hp2-hero-slider]');
    if (!slider || slider.dataset.psHp2SliderReady === 'true') return;

    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-ps-hp2-hero-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-ps-hp2-hero-dot]'));
    var desktopQuery = window.matchMedia('(min-width: 750px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var interval = Math.max(5000, parseInt(slider.dataset.psHp2HeroInterval, 10) || 7000);
    var activeIndex = 0;
    var timer = null;

    if (slides.length < 2 || dots.length !== slides.length) return;

    function hydrateSlides() {
      slides.slice(1).forEach(function (slide) {
        var image = slide.querySelector('[data-ps-hp2-hero-src]');
        if (!image || image.getAttribute('src')) return;
        if (image.dataset.psHp2HeroSrcset) image.setAttribute('srcset', image.dataset.psHp2HeroSrcset);
        image.setAttribute('src', image.dataset.psHp2HeroSrc);
      });
    }

    function showSlide(nextIndex) {
      if (!desktopQuery.matches) nextIndex = 0;
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === activeIndex);
      });
      dots.forEach(function (dot, index) {
        var isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!desktopQuery.matches || reduceMotion.matches || document.hidden) return;
      timer = window.setInterval(function () {
        showSlide(activeIndex + 1);
      }, interval);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        hydrateSlides();
        showSlide(parseInt(dot.dataset.psHp2HeroDot, 10) || 0);
        start();
      });
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);

    function handleViewportChange() {
      showSlide(desktopQuery.matches ? activeIndex : 0);
      if (desktopQuery.matches) hydrateSlides();
      start();
    }

    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', handleViewportChange);
    else desktopQuery.addListener(handleViewportChange);

    slider.dataset.psHp2SliderReady = 'true';
    slider.classList.add('is-slider-ready');
    if (desktopQuery.matches) {
      if ('requestIdleCallback' in window) window.requestIdleCallback(hydrateSlides, { timeout: 2200 });
      else window.setTimeout(hydrateSlides, 1000);
    }
    showSlide(0);
    start();
  }

  function initClosingVideo() {
    var host = document.querySelector('[data-ps-hp2-closing-video-host]');
    var video = host && host.querySelector('[data-ps-hp2-closing-video]');
    if (!host || !video || host.dataset.psHp2ClosingVideoReady === 'true') return;

    var desktopQuery = window.matchMedia('(min-width: 750px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var saveData = navigator.connection && navigator.connection.saveData;
    var hydrated = false;
    var isIntersecting = false;

    function hydrate() {
      if (hydrated || reduceMotion.matches || saveData) return;
      var src = desktopQuery.matches ? video.dataset.srcDesktop : video.dataset.srcMobile;
      if (!src) return;
      hydrated = true;
      video.muted = true;
      var poster = desktopQuery.matches ? video.dataset.posterDesktop : video.dataset.posterMobile;
      if (poster) video.poster = poster;
      video.addEventListener('playing', function () {
        host.classList.add('is-video-ready');
      });
      video.addEventListener('error', function () {
        host.classList.remove('is-video-ready');
      });
      video.src = src;
      video.load();
    }

    function play() {
      if (reduceMotion.matches || saveData) return;
      hydrate();
      var played = video.play();
      if (played && played.catch) played.catch(function () {
        host.classList.remove('is-video-ready');
      });
    }

    function pause() {
      if (!video.pause) return;
      try { video.pause(); } catch (error) {}
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isIntersecting = entry.isIntersecting;
          if (entry.isIntersecting) play();
          else pause();
        });
      }, { rootMargin: '120px 0px', threshold: 0.01 });
      observer.observe(host);
    }

    function handlePreferenceChange() {
      if (reduceMotion.matches) {
        pause();
        host.classList.remove('is-video-ready');
      } else if (isIntersecting) {
        play();
      }
    }

    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', handlePreferenceChange);
    else reduceMotion.addListener(handlePreferenceChange);

    host.dataset.psHp2ClosingVideoReady = 'true';
  }

  function initCarouselStatus() {
    var tracks = Array.prototype.slice.call(document.querySelectorAll('[data-ps-hp2-carousel]'));

    tracks.forEach(function (track) {
      var shell = track.closest('.ps-hp2-shell');
      var status = shell && shell.querySelector('[data-ps-hp2-carousel-status]');
      var current = status && status.querySelector('[data-ps-hp2-carousel-current]');
      var cards = Array.prototype.slice.call(track.children);
      var ticking = false;
      if (!status || !current || cards.length < 2) return;

      function update() {
        var target = track.scrollLeft + (track.clientWidth / 2);
        var active = 0;
        var distance = Infinity;
        cards.forEach(function (card, index) {
          var cardCenter = card.offsetLeft + (card.offsetWidth / 2);
          var nextDistance = Math.abs(cardCenter - target);
          if (nextDistance < distance) {
            distance = nextDistance;
            active = index;
          }
        });
        current.textContent = String(active + 1);
        ticking = false;
      }

      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  function initHomepage() {
    initHomepageHeader();
    initHeroSlider();
    initClosingVideo();
    initCarouselStatus();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHomepage);
  else initHomepage();
})();
